import getLangOriginal from 'I18n/utils/getLang';
import { ACADEMY_SUPPORTED_LANGUAGES } from '../constants/academySupportedLanguages';

/**
 * We want to make sure we limit the languages to the ones we support
 * If the users language is not supported we default to 'en'
 */
const getLang = () => {
  var _ACADEMY_SUPPORTED_LA;
  const lang = getLangOriginal().toLowerCase();
  return (_ACADEMY_SUPPORTED_LA = ACADEMY_SUPPORTED_LANGUAGES.map(v => v.toLowerCase()).find(value => value === lang)) !== null && _ACADEMY_SUPPORTED_LA !== void 0 ? _ACADEMY_SUPPORTED_LA : 'en';
};
export default getLang;